import React from 'react';
import './project-app-empty-state.scss';

interface ProjectAppEmptyStateProps {
  /**
   * True when Dream is actively building or processing the project app.
   * Switches the copy from "this is where your project will live" to
   * "getting your project ready".
   */
  building?: boolean;
}

/**
 * Shown on the canvas of a project thread that doesn't yet have a project
 * app. Indicates to the user that this is where their app/homepage will
 * live, and — when building — that Dream is putting it together.
 */
const ProjectAppEmptyState: React.FC<ProjectAppEmptyStateProps> = ({
  building = false,
}) => {
  return (
    <div className='project-app-empty-state'>
      <div className='project-app-empty-state__card'>
        <div className='project-app-empty-state__art' aria-hidden='true'>
          <img
            className='project-app-empty-state__art-docs'
            src='/splicons/project-empty-docs.png'
            alt=''
          />
        </div>
        <h2 className='project-app-empty-state__title'>
          {building
            ? 'Getting your project ready'
            : 'This is where your project will live'}
        </h2>
        <p className='project-app-empty-state__description'>
          {building
            ? 'Give me a minute. I\u2019m getting your one of a kind project app ready.'
            : 'Chat with me about your project and your one of a kind project app will appear here.'}
        </p>
      </div>
    </div>
  );
};

export default ProjectAppEmptyState;
